import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { TitleMediumText } from '@prisjakt/ui/text/variants';
import { SizeVariantSelectionButton } from './size-variant-selection-button';
import { IVariantsProps } from '../types';
import {
  VariantGridWrapper,
  VariantGridTitle,
  VariantGridCell,
} from './styles';

const compareNumericFn = (a?: string | null, b?: string | null) => {
  if (!a || !b) {
    return 1;
  }
  return a.localeCompare(b, undefined, {
    numeric: true,
    sensitivity: 'base',
  });
};

export const SizeVariantsGrid: React.FC<IVariantsProps> = props => {
  const { title, variants, handleSelection } = props;
  const { t } = useAppContext();
  const sortedVariants = variants?.sizes.filter(Boolean).sort(compareNumericFn);

  return (
    <VariantGridWrapper>
      {title && (
        <VariantGridTitle>
          <TitleMediumText>{title}</TitleMediumText>
        </VariantGridTitle>
      )}
      <VariantGridCell>
        <SizeVariantSelectionButton
          handleSelection={handleSelection}
          title={t('product', 'variants.all')}
          variant={null}
        />
      </VariantGridCell>
      {sortedVariants?.map(size => (
        <VariantGridCell key={size}>
          <SizeVariantSelectionButton
            handleSelection={handleSelection}
            title={size!}
            variant={size!}
          />
        </VariantGridCell>
      ))}
    </VariantGridWrapper>
  );
};
